import { setGenericChannel } from './chatFilterSetters';
const updateChannelFilter = (filters, filterValue) => {
  return setGenericChannel(filterValue, filters);
};
export default updateChannelFilter;